<template>
  <div class="scene-checkpoint-task">
    <BackButton @back="onBack" />

    <div class="tips">
      <span class="tip1">本关支线任务是：</span>
      <span class="tip2">{{taskName}}</span>
      <img class="sprite" src="/images/game/sprite-8.png" />
    </div>

    <div class="reward" v-if="taskStatus === 'reward'">
      <div class="content">
        <img class="card" src="/images/game/card.png" />
        <div class="tip">可凭此礼品卡去门店兑换相应礼品</div>
      </div>

      <div class="buttons" v-if="initReward">
        <img
          class="next-button"
          src="/images/game/cp-next-button.png"
          @click="onNextClick"
          v-if="checkpointId < 6"
        />
        <img class="next-button" src="/images/game/cp-lift-button.png" @click="onLiftClick" v-else />
      </div>
    </div>

    <div class="finished" v-if="taskStatus === 'finished'">
      <div class="content">
        <div class="resource" v-for="(item, index) in resArray" :key="index">
          <img class="image" :src="`/images/game/${item.name}-card.png`" />
          <div class="count">x {{item.count}}</div>
        </div>
      </div>

      <div class="buttons">
        <img class="card-button" src="/images/game/cp-card-button.png" @click="onCardClick" />
        <img
          class="next-button"
          src="/images/game/cp-next-button.png"
          @click="onNextClick"
          v-if="checkpointId < 6"
        />
        <img class="next-button" src="/images/game/cp-lift-button.png" @click="onLiftClick" v-else />
      </div>
    </div>

    <div class="unfinished" v-if="taskStatus === 'unfinished'">
      <div class="content">
        <div class="resource" v-for="(item, index) in resArray" :key="index">
          <img class="image" :src="`/images/game/${item.name}-card.png`" />
          <div class="count">x {{item.count}}</div>
        </div>
      </div>

      <div class="buttons">
        <img class="replay-button" src="/images/game/cp-replay-button.png" @click="onReplay" />
        <img class="next-button" src="/images/game/cp-next-button.png" @click="onNextClick" />
      </div>
    </div>

    <div class="package">
      <div class="title">我的背包：</div>
      <div class="resource" v-for="(item, index) in packageArray" :key="index">
        <img class="image" :src="`/images/game/${item.name}-active.png`" v-if="item.count > 0" />
        <img class="image" :src="`/images/game/${item.name}-default.png`" v-else />
        <div class="count">{{item.count}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import BackButton from "../common/BackButton";

export default {
  name: "CheckpointTaskScene",
  components: {
    BackButton
  },
  data() {
    return {
      initReward: true,
      reward: {
        id: 0
      },
      resArray: [
        {
          name: "赤霞珠",
          count: 0
        }
      ]
    };
  },
  computed: {
    copyId: function() {
      return this.$store.state.game.copyId;
    },
    checkpointId: function() {
      return this.$store.state.game.currentCheckpointId;
    },
    taskName: function() {
      return this.$store.state.game.gameCheckpoint.get.taskName;
    },
    taskStatus: function() {
      return this.$store.state.game.taskStatus;
    },
    backgroundImage: function() {
      return `/images/game/task-${this.$store.state.game.taskStatus}.png`;
    },
    resourceArray: function() {
      return this.$store.state.game.gameResource.retrieve.results;
    },
    result: function() {
      return `/images/game/${this.$store.state.game.currentCheckpointResult}-background.png`;
    },
    packageArray() {
      const response = this.$store.state.game.common.getMyBackpack;

      return [
        "赤霞珠",
        "梅洛",
        "西拉",
        "黑皮诺",
        "霞多丽",
        "长相思",
        "雷司令"
      ].map(name => {
        const r = response.find(e => e.name == name);
        if (r != null) {
          return {
            name,
            count: r.count
          };
        } else {
          return {
            name,
            count: 0
          };
        }
      });
    }
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      if (this.taskStatus == "reward") {
        this.initReward = false;
      }

      let response;

      response = await this.ajax.doPost({
        packageName: "game",
        className: "common",
        methodName: "getResourceByCopyId",
        params: {
          copyId: this.copyId
        }
      });

      this.resArray = [response];

      response = await this.ajax.doPost({
        packageName: "game",
        className: "common",
        methodName: "getRewardByCheckpointId",
        params: {
          checkpointId: this.checkpointId
        }
      });

      this.reward = response;

      console.log(this.taskStatus);

      if (this.reward.id > 0 && this.taskStatus !== "reward") {
        this.$store.commit("setTaskStatus", "finished");
      }

      await this.$store.dispatch("post", {
        packageName: "game",
        className: "common",
        methodName: "getMyBackpack",
        params: {}
      });
    },
    onCardClick() {
      this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
      this.$store.commit("setTaskStatus", "reward");

      this.ajax.doPost({
        packageName: "game",
        className: "common",
        methodName: "setCardExchange",
        params: {
          checkpointId: this.checkpointId
        }
      });
    },
    onNextClick() {
      this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
      this.$store.commit("setCurrentCheckpointId", this.checkpointId + 1);
      this.$emit("changeScene", "CheckpointStartScene");
    },
    onLiftClick() {
      this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
      this.$emit("changeScene", "GameOverScene");
    },
    onBack() {
      this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
      this.$emit("changeScene", "MainScene");
    },
    onReplay() {
      this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
      this.$emit("changeScene", "CheckpointStartScene");
    }
  }
};
</script>


<style lang="scss" scoped>
.scene-checkpoint-task {
  width: 1100px;
  height: 560px;
  position: relative;

  background-image: url("/images/game/result-background.png");
  background-size: cover;

  .tips {
    position: absolute;
    top: 30px;
    left: 740px;
    height: 53px;

    line-height: 53px;
    .tip1 {
      font-size: 14px;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      vertical-align: top;
    }

    .tip2 {
      font-size: 14px;
      font-weight: 600;
      color: #d5b578;
      vertical-align: top;
    }

    .sprite {
      vertical-align: top;
      margin-left: 10px;
      width: 72px;
      height: 53px;
    }
  }

  @keyframes backgroundmove {
    from {
      left: -825px;
    }

    to {
      left: 137.5px;
    }
  }

  @keyframes contentmove {
    from {
      transform: translateX(1100px);
    }

    to {
      transform: translateX(0px);
    }
  }

  .unfinished {
    position: absolute;
    top: 47px;
    left: 137.5px;
    width: 825px;
    height: 345px;
    text-align: center;
    background-size: cover;
    background-image: url(/images/game/task-unfinished.png);

    animation: backgroundmove 1s;

    .content {
      margin-top: 100px;

      animation: contentmove 1s;
    }

    .buttons {
      animation: contentmove 1s;
    }
  }

  .finished {
    position: absolute;
    top: 0px;
    left: 137.5px;
    width: 825px;
    height: 392px;
    text-align: center;
    background-size: cover;
    background-image: url(/images/game/task-finished.png);

    animation: backgroundmove 1s;
    .content {
      margin-top: 147px;

      animation: contentmove 1s;
    }

    .buttons {
      animation: contentmove 1s;
    }
  }

  .reward {
    position: absolute;
    top: 0px;
    left: 137.5px;
    width: 825px;
    height: 392px;
    text-align: center;
    background-size: cover;
    background-image: url(/images/game/task-reward.png);

    animation: backgroundmove 1s;

    .content {
      margin-top: 147px;

      animation: contentmove 1s;

      .card {
        margin-top: 20px;
        width: 280px;
        height: 156px;
      }

      .tip {
        margin-top: 20px;
        margin-bottom: 40px;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 20px;
        opacity: 0.3;
      }
    }

    .buttons {
      animation: contentmove 1s;
    }
  }

  .resource {
    z-index: 999;
    margin: 0px 5px 0 5px;
    display: inline-block;
    .image {
      width: 128px;
      height: 210px;
    }

    .count {
      height: 22px;
      line-height: 22px;
      font-size: 22px;
      font-family: "DINMedium";
      color: rgba(255, 233, 191, 1);
    }
  }

  .buttons {
    margin-top: 20px;
    text-align: right;

    .card-button,
    .replay-button,
    .next-button {
      width: 130px;
      height: 34px;
      margin-right: 10px;
      cursor: pointer;
    }

    .card-button:hover,
    .replay-button:hover,
    .next-button:hover {
      box-shadow: 0px 2px 7px 7px rgba(250, 100, 0, 0.43);
    }
  }

  @keyframes packagemove {
    from {
      left: -1100px;
    }

    to {
      left: 0;
    }
  }

  .package {
    position: absolute;
    bottom: 0px;

    width: 1100px;
    height: 90px;
    background: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.49) 49%,
      rgba(0, 0, 0, 0) 100%
    );
    opacity: 0.7;

    animation: packagemove 1s;

    .title {
      vertical-align: top;
      display: inline-block;

      margin: 0 20px 0 200px;
      height: 90px;
      font-size: 16px;
      font-weight: 600;
      color: rgba(213, 181, 120, 1);
      line-height: 90px;
    }

    .resource {
      vertical-align: top;
      display: inline-block;
      margin-right: 30px;

      text-align: center;
      .image {
        margin-top: 10px;
        width: 41px;
        height: 44px;
      }

      .count {
        font-size: 18px;
        font-family: "DINMedium";
        font-weight: bold;
        color: rgba(213, 181, 120, 1);
        line-height: 22px;
      }
    }
  }
}
</style>